<template>
  <div class="menu is-print-hide">
    <el-menu active-text-color="#1E8DFF" :default-active="actRouter" ref="menus">
      <el-submenu index="1" v-if="isSupervision" @click.native="handleClick('2')">
        <template slot="title">
          <span class="sub_title">智云问诊</span>
        </template>
        <item
          v-for="(route, index) in permission_routes"
          :permissionRoutes="permission_routes"
          :key="index"
          :item="route"
          @click="jump(route)"
        ></item>
      </el-submenu>
      <item
        v-for="(route, index) in permission_routes"
        :permissionRoutes="permission_routes"
        :key="index"
        :item="route"
        @click="jump(route)"
        v-else
      ></item>
      <el-submenu index="2" v-if="isSupervision" style="margin-top: 12px" @click.native="handleClick('1')">
        <template slot="title">
          <span class="sub_title">数字药监</span>
        </template>
        <template v-for="(sitem, sindex) in supervision_routes">
          <el-menu-item
            class="sub-menu-item"
            v-if="!sitem.children"
            :index="sitem.path"
            @click.native="pageTo(sitem.path)"
            :key="sindex"
          >
            <span class="el-submenu iconfont" :class="sitem.icon" slot="title">
              <span class="icon-menu">{{ sitem.title }}</span>
            </span>
          </el-menu-item>
          <el-submenu v-else :index="sitem.path" :key="sitem.path">
            <span class="el-submenu iconfont" :class="sitem.icon" slot="title">
              <span class="title">{{ sitem.title }}</span>
            </span>
            <el-menu-item
              v-for="(citem, key) in sitem.children"
              @click="pageTo(citem.path)"
              :index="citem.path"
              :key="key"
            >
              <span slot="title">{{ citem.title }}</span>
            </el-menu-item>
          </el-submenu>
        </template>
      </el-submenu>
    </el-menu>

    <!-- <div class="item-box">
      <item
          v-for="(route, index) in permission_routes"
          :permissionRoutes="permission_routes"
          :key="index"
          :item="route"
          @click="jump(route)"
        ></item>
      </div> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import item from './item';
import { version } from '@/setting.js';
export default {
  components: {
    item
  },
  // data() {
  //   return {

  //   };
  // },
  mounted() {},
  computed: {
    ...mapGetters(['permission_routes', 'supervision_routes', 'isSupervision']),
    actRouter() {
      const {
        path,
        meta: { parent, belong }
      } = this.$route || {};

      return belong || path;
    },
    companyName() {
      return this.$store.getters.companyName;
    },
    storeList() {
      return this.$store.getters.storeList;
    },
    // pc左侧活动
    pcLeftLabel() {
      const { resourcePutObj } = this.$store.getters;
      const RESOURCE_TYPE = 'PC_LEFT_LABEL';
      if (resourcePutObj[RESOURCE_TYPE]) return resourcePutObj[RESOURCE_TYPE];
      return [];
    },
    // pc左侧活动是否展示
    pcLeftLabelShow() {
      const { pcLeftLabel } = this;
      if (pcLeftLabel.length) {
        const { id } = pcLeftLabel[0];
      }
      if (pcLeftLabel.length) {
        Telescope.trackEvent({
          trackId: 'zywzpc-click-biaoqian-b'
        });
      }

      return !!pcLeftLabel.length;
    }
  },
  methods: {
    renderVer() {
      return version;
    },
    jump(route) {
      this.$refs.menus.close('2');
      if (!route.meta.externalLink) {
        if (this.$route.path == route.path) {
          return;
        }
        this.$router.push(route.path);
      } else {
        location.href = route.path;
      }
    },
    handleClick(active) {
      this.$refs.menus.close(active);
    },
    pageTo(path) {
      this.$refs.menus.close('1');
      this.$router.push(path);
    }
  }
};
</script>
<style lang="less" scoped>
.menu {
  // float: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  background: #fff;
  overflow-y: auto;
  width: 200px;
  height: 100%;
  padding-top: 4px;
  padding-bottom: 80px;
  // overflow: hidden;
  z-index: 20;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  .sub_title {
    font-size: 16px;
    color: #262626;
    font-weight: 500;
    //   position: relative;
    //   top: -4px;
  }
  /deep/.el-submenu__title {
    padding: 0 !important;
    margin: 0 17px !important;
    border-bottom: 1px solid rgba(237, 237, 237, 0.5);
    height: 48px;
    line-height: 48px;
    &:hover {
      background: #fff;
    }
  }
  /deep/.el-menu-item {
    font-size: 14px;
    position: relative;
    top: -4px;
    color: #262626;
    // border-bottom: 1px solid rgba(237,237,237, 0.5);
    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      font-size: 20px;
      left: 17px;
      width: 166px;
      height: 1px;
      background: rgba(237, 237, 237, 0.5);
    }
    height: 48px;
    line-height: 48px;
    padding-left: 44px !important;
    &.is-active {
      background: #f4f9ff;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 3px;
        height: 48px;
        background: #1e8dff;
      }
    }
  }
  .el-submenu {
    font-size: 14px;
    line-height: 22px;
    color: #262626;
    &::before {
      font-size: 20px;
      display: inline-block;
      margin-right: 14px;
      // position: relative;
      // top: 2px;
    }
  }
  .sub-menu-item {
    padding-left: 17px !important;
  }
  .title {
    position: relative;
    top: -4px;
    left: -8px;
  }
  .icon-menu {
    position: relative;
    left: -6px;
    top: -3px;
  }
  /deep/.el-submenu__icon-arrow {
    color: #8c8c8c;
    font-size: 12px;
    margin-top: -5px;
    right: 0;
  }
}
</style>
